import { render, staticRenderFns } from "./ai-workspaces.vue?vue&type=template&id=22bf7dab&scoped=true"
import script from "./ai-workspaces.vue?vue&type=script&lang=js"
export * from "./ai-workspaces.vue?vue&type=script&lang=js"
import style0 from "./ai-workspaces.vue?vue&type=style&index=0&id=22bf7dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf7dab",
  null
  
)

export default component.exports